<template>
  <a-table
    v-if="device !== 'mobile'"
    :columns="columns"
    :dataSource="data"
    size="small"
  >
    <a slot="name" slot-scope="text" href="javascript:;">{{text}}</a>
    <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
    <span slot="tags" slot-scope="tags">
      <h1 v-for="tag in tags" color="blue" :key="tag">{{tag}}</h1>
    </span>
    <span slot="action" slot-scope="text, record">
      <a href="javascript:;">Invite 一 {{record.name}}</a>
      <a-divider type="vertical" />
      <a href="javascript:;">Delete</a>
      <a-divider type="vertical" />
      <a href="javascript:;" class="ant-dropdown-link">
        More actions <a-icon type="down" />
      </a>
    </span>
  </a-table>
  <div v-else>
    <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
      <a-descriptions-item
        v-for="( itm, i) in columns" :key="`item${i}`"
        :label="itm.title"
      >
      <a v-if="itm.dataIndex === 'name'" href="javascript:;"> {{item[itm.dataIndex]}}</a>
      <span v-if="itm.dataIndex === 'customTitle'"><a-icon type="smile-o" /> Name</span>
      <span v-if="itm.dataIndex === 'tags'">
        <h1 v-for="tag in tags" color="blue" :key="tag">{{tag}}</h1>
      </span>
      <span v-if="itm.dataIndex === 'action'">
        <a href="javascript:;">Invite 一 {{item.name}}</a>
        <a-divider type="vertical" />
        <a href="javascript:;">Delete</a>
        <a-divider type="vertical" />
        <a href="javascript:;" class="ant-dropdown-link">
          More actions <a-icon type="down" />
        </a>
      </span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
const columns = [{
  dataIndex: 'name',
  key: 'name',
  slots: { title: 'customTitle' },
  scopedSlots: { customRender: 'name' }
}, {
  title: 'Age',
  dataIndex: 'age',
  key: 'age'
}, {
  title: 'Address',
  dataIndex: 'address',
  key: 'address'
}, {
  title: 'Tags',
  key: 'tags',
  dataIndex: 'tags',
  scopedSlots: { customRender: 'tags' }
}, {
  title: 'Action',
  key: 'action',
  scopedSlots: { customRender: 'action' }
}]

const data = [{
  key: '1',
  name: 'John Brown',
  age: 32,
  address: 'New York No. 1 Lake Park',
  tags: ['nice', 'developer']
}, {
  key: '2',
  name: 'Jim Green',
  age: 42,
  address: 'London No. 1 Lake Park',
  tags: ['loser']
}, {
  key: '3',
  name: 'Joe Black',
  age: 32,
  address: 'Sidney No. 1 Lake Park',
  tags: ['cool', 'teacher']
}]

export default {
  data () {
    return {
      data,
      columns
    }
  }
}
</script>
